import { render, staticRenderFns } from "./OnlinePaymentConfig.vue?vue&type=template&id=053859d2"
import script from "./OnlinePaymentConfig.vue?vue&type=script&lang=js"
export * from "./OnlinePaymentConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports